var _rect, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFindingsBoiIconHover = function SvgFindingsBoiIconHover(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 28.5,
    height: 28.5,
    rx: 14.25,
    stroke: "#FF9900",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0193 23L16.174 17.1548C15.7087 17.539 15.1736 17.8396 14.5687 18.0568C13.9637 18.2739 13.3379 18.3825 12.6913 18.3825C11.1006 18.3825 9.75442 17.8318 8.65265 16.7303C7.55088 15.6288 7 14.2829 7 12.6927C7 11.1025 7.55074 9.75614 8.65223 8.65368C9.75372 7.55122 11.0996 7 12.6898 7C14.28 7 15.6264 7.55088 16.7288 8.65265C17.8313 9.75442 18.3825 11.1006 18.3825 12.6913C18.3825 13.3558 18.271 13.9906 18.0479 14.5955C17.8247 15.2004 17.527 15.7266 17.1548 16.174L23 22.0193L22.0193 23ZM12.6913 16.9866C13.8904 16.9866 14.906 16.5705 15.7383 15.7383C16.5705 14.906 16.9866 13.8904 16.9866 12.6913C16.9866 11.4921 16.5705 10.4765 15.7383 9.64426C14.906 8.81204 13.8904 8.39593 12.6913 8.39593C11.4921 8.39593 10.4765 8.81204 9.64426 9.64426C8.81206 10.4765 8.39595 11.4921 8.39595 12.6913C8.39595 13.8904 8.81206 14.906 9.64426 15.7383C10.4765 16.5705 11.4921 16.9866 12.6913 16.9866ZM11.9933 15.1968V13.3892H10.1857V11.9933H11.9933V10.1857H13.3893V11.9933H15.1969V13.3892H13.3893V15.1968H11.9933Z",
    fill: "#FF9900"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFindingsBoiIconHover, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/findings-boi-icon-hover.567d5dd6.svg";
export { ForwardRef as ReactComponent };